import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  ApplicationRouteURL
} from "../../shared/config";
import { RoleModel } from "../models/role.model";
import { TranslateService } from "../../shared/translate/index";
import { RoleService } from "../models/role.service";
import { AuthService } from "../../shared/models/auth.service";
import { AccessMatrixModel } from "../models/access-matrix.model";
import { retry } from "rxjs/operator/retry";
import { Math } from "core-js/library/web/timers";

@Component({
  selector: "wego-role",
  template: require('../views/role-update.component.html'),
  providers: [RoleService]
})
export class RoleUpdateComponent implements OnInit, OnDestroy {
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
  public itemsPerPage: number = WeGoConfig.GRID_MAX_DATA_SIZE;
  private roleHashId: string;
  private sub: any;
  isLoading: boolean;
  model: RoleModel;
  entityList: RoleModel[];
  accessibilityMatrixList: AccessMatrixModel[];
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;

  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  public searchField: string = "";
  public searchTerm: string = "";

  urlDefaultPage: string;
  urlRoleList: string;

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("copyRoleModal") public copyRoleModal: any;

  constructor(
    private roleService: RoleService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private locationService: Location
  ) { }

  ngOnInit(): void {
    this.module = this.translate.instant("LblRoleManagement");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlRoleList = this.authService.GetURL(
      ApplicationRouteURL.URL_ROLE_LIST
    );
    this.model = new RoleModel();
    this.GetEntityDropdownList();
    this.GetRoleDetails();
  }

  public GetRoleDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.roleHashId = params["id"] || "";
      if (this.roleHashId != "") {
        this.isLoading = true;
        this.isEditMode = true;
        this.roleService.GetRoleByHashId(this.roleHashId).subscribe(
          res => {
            this.model = res.data;
            this.accessibilityMatrixList = this.model.accessList;
            this.isLoading = false;
          },
          error => {
            this.isLoading = false;
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );
      } else {
        this.isEditMode = false;
        this.model = new RoleModel();
        this.model.entity = "";
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  public GetEntityDropdownList(): any {
    this.isLoading = true;
    this.roleService.GetEntityDropdownList().subscribe(
      res => {
        this.entityList = res.data;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }


  public OnViewCheckBoxChange(item: any, isChecked: any): any {
    if (!isChecked) {
      item.insert = false;
      item.edit = false;
      item.delete = false;
    }
  }

  public UpdateAccessMatrix(): any {
    if (this.model.entity != null && this.model.entity.length > 0) {
      var selectedDefaultRole = this.entityList.find(
        x => x.entity === this.model.entity
      );
      if (selectedDefaultRole != null) {
        this.isLoading = true;
        this.roleService
          .GetAccessibilityMatrixByRoleHashId(selectedDefaultRole.roleHashId)
          .subscribe(
          res => {
            this.accessibilityMatrixList = res.data;
            this.isLoading = false;
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
          );
      }
    } else {
      this.accessibilityMatrixList = [];
    }
  }

  public CopyRoleAccessMatrix($event: any) {
    let copyAccess: AccessMatrixModel[] = $event.accessibilityMatrixList;
    this.accessibilityMatrixList.forEach(x => {
      let updatedAccess = copyAccess.find(
        y => y.permissionHashId == x.permissionHashId
      );
      if (updatedAccess) {
        x.view = updatedAccess.view;
        x.insert = updatedAccess.insert;
        x.edit = updatedAccess.edit;
        x.delete = updatedAccess.delete;
      }
    });
  }

  onSubmit(forms: any) {
    this.model.accessList = this.accessibilityMatrixList;
    this.AddNewRole();
  }

  public AddNewRole() {
    this.roleService.AddRole(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
            : this.translate.instant("LblRecordAddedSuccess", [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public CopyRolePopup(): any {
    this.copyRoleModal.selectedRoleEntity = this.model;
    this.copyRoleModal.show();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role-management/components/role-update.component.ts